import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
const limit = 10;
const EmojiCard = (props) => {
  const userList = props.emojiReaction["userList"];

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      key={props.index}
      placement="top"
      overlay={
        <Popover id="popover-trigger-focus">
          <Popover.Content>
            <div className="emoji-user-list">
              {userList.slice(0, limit).map((user) => (
                <span>{user}</span>
              ))}
              {userList.length > limit && (
                <span>and {userList.length - limit} others</span>
              )}
              &nbsp;{props.emojiReaction["emoji"]}
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <div
        className="emoji-reply-content d-flex"
        onClick={props.removeEmojiReaction}
      >
        <div className="emoji-icon">{props.emojiReaction["emoji"]}</div>
        <div className="emoji-count text-col-1 bold">
          {props.emojiReaction["userList"].length}
        </div>
      </div>
    </OverlayTrigger>
  );
};

export default EmojiCard;
